import Vue from 'vue';
import Router from 'vue-router';
// import App from './App.vue';
// import Default from './Default';

function lazyLoading(name) {
    return function () {
        return import(`./views/${name}.vue`);
    };
}

Vue.use(Router);

export default new Router({
    base: process.env.VUE_APP_ROUTER_BASE,
    mode: 'history',
    linkActiveClass: 'active',
    routes: [
        {
            path: '/',
            name: 'home',
            component: lazyLoading('Home'),
        },
        {
            path: '/women',
            name: 'women',
            component: lazyLoading('List'),
        },
        {
            path: '/men',
            name: 'men',
            component: lazyLoading('List'),
        },
        {
            path: '/contact',
            name: 'contact',
            component: lazyLoading('Contact'),
        },
        {
            path: '/detail/:id?',
            name: 'detail',
            component: lazyLoading('Detail'),
            props: true,
        },
        {
            path: '/news/:id?',
            name: 'news',
            props: (route) => ({
                searchKey: route.query.searchKey,
            }),
            component: lazyLoading('News'),
        },
        {
            path: '*',
            redirect: '/',
        },
    ],
});
